import {
  Box,
  Button,
  Flex,
  Grid,
  Image,
  PasswordInput,
  Text,
  TextInput,
} from "@mantine/core";
import useStyles from "./style";
import LinePatternSvg from "../../components/Svgs/LinePatternSvg";
import { GoogleLogin } from "@react-oauth/google";
import { useForm } from "@mantine/form";
import { Link, useNavigate } from "react-router-dom";
import { googleLogin, login, login_Skypoint } from "../../services";
import { useSelector } from "react-redux";

const SkypointLogin = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.auth);

  const form = useForm({
    initialValues: {
      email: "",
      password: "",
    },

    validate: {
      email: (value) => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return !value
          ? "Required"
          : emailRegex.test(value)
          ? null
          : "Please enter a valid email address";
      },
      password: (value) => (value ? null : "Required"),
    },
  });

  return (
    <Grid className={classes.container}>
      <Grid.Col span={12} md={6} className={classes.leftCol}>
        <Flex direction="column" align="center" className={classes.leftContent}>
          <Box className={classes.LogoBar} pr={14} pb={20} h={76} w="100%">
            <Image
              src="/assets/images/skypoint-logo2.png"
              height={44}
              width={144}
            />
          </Box>
          <Flex
            direction="column"
            justify="center"
            gap={32}
            className={classes.formAndHdngWrapper}
          >
            <Flex direction="column" gap={12}>
              <Text fz={36} fw={600} ff="Inter" color="#171717">
                Log in
              </Text>
              <Text fz={16} fw={400} ff="Inter" color="#737373">
                Welcome back! Please enter your details.
              </Text>
            </Flex>
            {/* <form onSubmit={form.onSubmit((values) => login_Skypoint(values, navigate))}> */}
            <form
              onSubmit={form.onSubmit((values) =>
                login_Skypoint(
                  { ...values, platform: "Skypoint" }, // ⬅️ Add this line
                  navigate
                )
              )}
            >
              <Flex direction="column" gap={20}>
                <TextInput
                  id="login-email"
                  className={classes.inputField}
                  label="Email"
                  placeholder="Enter your email"
                  {...form.getInputProps("email")}
                  size="lg"
                />
                <PasswordInput
                  className={classes.inputField}
                  id="login-password"
                  label="Password"
                  placeholder="*****"
                  {...form.getInputProps("password")}
                  size="lg"
                />
              </Flex>
              <Link
                to="/skypoint-forget-password"
                className={classes.forgotPasswordLink}
              >
                Forgot Password?
              </Link>
              <Flex direction="column" align="center" gap={16}>
                <Button
                  id="login-button"
                  className={classes.loginBtn}
                  type="submit"
                  loading={loading}
                >
                  Sign in
                </Button>
                <GoogleLogin
                  size="large"
                  text=""
                  logo_alignment="center"
                  onSuccess={(credentialResponse) => {
                    googleLogin(
                      {
                        client_id: credentialResponse?.clientId,
                        jwtToken: credentialResponse?.credential,
                      },
                      navigate
                    );
                  }}
                  onError={() => {
                    console.log("Login Failed");
                  }}
                />
              </Flex>
            </form>
            <Flex
              justify="center"
              align="center"
              gap={4}
              className={classes.signupLinkText}
            >
              <Text fz={14} fw={400} ff="Inter" color="#737373">
                Don't have an account?
              </Text>
              <Link className="signupLink" to={"/skypoint-signup"}>
                Sign up
              </Link>
            </Flex>
          </Flex>
        </Flex>
      </Grid.Col>
      <Grid.Col span={12} md={6} className={classes.rightCol}>
        <Flex
          className={classes.rightContent}
          align="center"
          justify="flex-end"
        >
          <Box className={classes.linePattern1Parent}>
            <LinePatternSvg />
          </Box>
          <img
            src="/assets/images/skypoint-dashboard.png"
            alt=""
            className={classes.dashboardImg}
          />
          <Box className={classes.linePattern2Parent}>
            <LinePatternSvg />
          </Box>
        </Flex>
      </Grid.Col>
    </Grid>
  );
};

export default SkypointLogin;
